import { render } from "./NumericData.vue?vue&type=template&id=64a87d65"
import script from "./NumericData.vue?vue&type=script&lang=js"
export * from "./NumericData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__